import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Answer, Question } from '../../../services/questions.service';

@Component({
    selector: 'app-quiz-stats',
    templateUrl: './quiz-stats.component.html',
    styleUrls: ['./quiz-stats.component.scss'],
    standalone: false,
})
export class QuizStatsComponent implements OnInit {
    @Input() answers!: Answer[];
    @Input() questions!: Question[];
    @Output() showClose = new EventEmitter<boolean>();
    @Output() countdown = new EventEmitter<number>();

    private countdownValue = 30;
    intervalId: any;

    ngOnInit() {
        if (this.allCorrect()) {
            setTimeout(() => {
                this.showClose.emit(true);
            }, 100);
        } else {
            setTimeout(() => {
                this.showClose.emit(true);
            }, 30000);

            this.startCountdown();
        }
    }

    getChosenAnswerText(question: Question, answer: any): string {
        if (!answer) return 'Geen antwoord';
        const choice = question.choices.find(c => c.id === answer.choice_id);
        return choice ? choice.text : 'Geen antwoord';
    }

    isCorrect(question: Question, answer: any): boolean {
        if (!answer) return false;
        const choice = question.choices.find(c => c.id === answer.choice_id);
        return !!(choice && choice.is_correct);
    }

    allCorrect(): boolean {
        return this.questions.every((q, i) => this.isCorrect(q, this.answers[i]));
    }

    getCorrectAnswerText(question: Question): string {
        const correct = question.choices.find(c => c.is_correct);
        return correct ? correct.text : 'Onbekend';
    }

    startCountdown() {
        this.intervalId = setInterval(() => {
            this.countdownValue--;

            this.countdown.emit(this.countdownValue);
            if (this.countdownValue <= 0) {
                clearInterval(this.intervalId);
                this.countdown.emit(0);
            }
        }, 1000);
    }
}
